import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

const propTypes = {
  viewIndex: PropTypes.number.isRequired,
};

const ViewIndicator = ({ viewIndex }) => {
  const getXPosition = () => `${viewIndex * 25}%`;

  return (
    <div className="w-full p-1 md:p-4">
      <div className="w-3/4 md:w-1/2 mx-auto bg-light-grey h-1.5 rounded-full relative">
        <motion.div
          initial={{ left: 0 }}
          animate={{ left: getXPosition() }}
          className="absolute left-0 h-full w-1/4 bg-black rounded-full"
        />
      </div>
    </div>
  );
};

ViewIndicator.propTypes = propTypes;

export default ViewIndicator;
